import Home from '../../assets/icons/Home';
import Text from '../../assets/icons/Text';
import Cam from '../../assets/icons/Cam';
import { useNavigate } from 'react-router';

const TutorDashboardSidebar = () => {
  const navigate = useNavigate();

  const sidebarIcons = [
    { id: 1, icon: Home, link: '/tutor-dashboard' },
    { id: 2, icon: Text, link: '/tutor/courses' },
    { id: 3, icon: Cam, link: '/tutor/live-classes' },
  ];
  return (
    <div className='tutor-sidebar'>
      {sidebarIcons.map((el) => (
        <div
          key={el.id}
          className={
            window.location.pathname === el.link
              ? 'tutor-sidebar__active-icon'
              : 'tutor-sidebar__icon'
          }
          onClick={() => navigate(el.link)}
        >
          <el.icon />
        </div>
      ))}
    </div>
  );
};

export default TutorDashboardSidebar;
